import type { FireflyRuntime, NavigationLinkAdditionalProps } from "@sg-protect/federation-runtime";
import type { ReactNode } from "react";
import { ProtectUserMenuId } from "./constants.ts";

export interface ProtectUserMenuItemOptions {
    id: string;
    label: string;
    to: string;
    icon: ReactNode;
    priority: number;
}

export function registerProtectUserMenuItem(
    runtime: FireflyRuntime,
    { id, label, to, icon, priority }: ProtectUserMenuItemOptions
) {
    runtime.registerNavigationItem(
        {
            $id: id,
            $label: label,
            to,
            $priority: priority,
            $additionalProps: {
                icon
            } satisfies NavigationLinkAdditionalProps
        },
        {
            menuId: ProtectUserMenuId
        }
    );
}
